<template>
  <v-container class="fill-height">
    <v-row v-if="parkingContent">
      <v-col md="10" offset-md="1">
        <v-alert type="success" v-if="success">
          Parking successfully edited
        </v-alert>
        <v-alert type="error" v-if="error">
          Something went wrong. Please check the developer console!
        </v-alert>
        <v-tabs v-model="languageTab" background-color="transparent">
          <v-tab v-for="language in languages" :key="language.code" :href="'#' + language.code">
            {{ language.name }}
          </v-tab>
        </v-tabs>
        <v-form @submit.prevent="handleSubmit" id="parking-create-form" class="parking-create-form" ref="createParkingForm" v-model="isValid">
          <div v-for="language in languages" :key="language.code" v-show="language.code === languageTab">
              <v-row>
              <v-col md="4">
                <v-autocomplete v-model="selectedBuilding" class="building-autocomplete" prepend-icon="mdi-office-building" :items="getAutocompleteValues(buildings)" label="Изберете сграда" :rules="[rules.required]" required />
              </v-col>
              <v-col md="4" v-if="selectedBuilding">
                <v-autocomplete v-model="selectedEntrance" class="building-autocomplete" prepend-icon="mdi-office-building" :items="getAutocompleteValues(entrances)" label="Изберете вход" :rules="[rules.required]" required />
              </v-col>
              <v-col md="4" v-if="selectedBuilding && selectedEntrance">
                <v-autocomplete v-model="selectedFloor" class="building-autocomplete" prepend-icon="mdi-office-building" :items="getAutocompleteValues(floors)" label="Изберете етаж" :rules="[rules.required]" required />
              </v-col>
            </v-row>
              <v-row>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-pencil" label="Заглавие" v-model="parkingContent[language.code].title" :rules="[rules.required]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-currency-usd" label="Цена" v-model="price" :rules="[rules.required, rules.number]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field name="title" prepend-icon="mdi-textarea" label="Total area" v-model="totalArea" :rules="[rules.required, rules.number]" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-select :items="statuses" prepend-icon="mdi-help-circle" item-text="state" item-value="abbr" label="Статус" v-model="status" :rules="[rules.required]" required></v-select>
                </v-col>
              </v-row>
              <v-row>
              <v-col md="12">
                <v-textarea prepend-icon="mdi-map-marker-path" v-model="coordinates" name="coordinates" label="Координати"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
                <v-col md="3">
                    <v-switch value label="Паркинг на Бокал" color="indigo" v-model="isBokalParking"></v-switch>
                </v-col>
            </v-row>
          </div>
        </v-form>
        <v-btn color="success" type="submit" form="parking-create-form">Запиши</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { updateParking } from '@/repositories/parking.repository'
export default {
  data () {
    return {
      status: null,
      totalArea: 0,
      isBokalParking: false,
      price: 0.0,
      coordinates: null,
      isValid: false,
      languageTab: null,
      parkingContent: null,
      selectedBuilding: null,
      selectedEntrance: null,
      selectedFloor: null,
      statuses: [
        { state: 'Свободен', abbr: 1 },
        { state: 'Продаден', abbr: 3 },
        { state: 'Резервиран', abbr: 2 }
      ],
      rules: {
        required: value => !!value || 'Това поле е задължително!',
        number: value => /^\d*\.?\d*$/.test(value) || 'Цената трябва да е число'
      },
      success: false,
      error: false
    }
  },
  created () {
    this.$store.dispatch('fetchLanguages')
      .then(() => {
        this.parkingContent = {};
        for (const language of this.languages) {
          this.parkingContent[language.code] = {
            title: null
          };
        }

        this.$store.dispatch('fetchParking', this.$route.params.id)
      })

    this.$store.dispatch('fetchBuildings')
    this.$store.dispatch('fetchEntrances')
    this.$store.dispatch('fetchFloors')
  },
  computed: {
    languages () {
      return this.$store.state.language.languages
    },
    buildings () {
      return this.$store.state.building.buildings
    },
    entrances () {
      return this.$store.state.entrance.entrances
    },
    floors () {
      return this.$store.state.floor.floors
    },
    parking () {
        return this.$store.state.parking.parking
    },
    buildingsAutocompleteValues () {
      const buildings = [...this.buildings]
      return buildings.map(building => ({
        text: building.translations ? building.translations.title : '',
        value: building.id
      }))
    }
  },
  watch: {
    parking (parking) {
      if (parking) {
        this.setParkingValue()
      }
    }
  },
  methods: {
    setParkingValue () {
      this.selectedBuilding = this.parking.buildingId
      this.selectedEntrance = this.parking.entranceId
      this.selectedFloor = this.parking.floorId

      this.price = this.parking.price
      this.totalArea = this.parking.totalArea
      this.coordinates = this.parking.coordinates
      this.status = this.parking.status
      this.isBokalParking = this.parking.isBokalParking

      const parkingTranslations = this.parkingContent[this.languageTab]
      this.parking.translations.title && (parkingTranslations.title = this.parking.translations.title)
    },
    getAutocompleteValues (objectData) {
        const data = objectData
        return data.map(d => ({
            text: d.translations ? d.translations.title : '',
            value: d.id
        }))
    },
    handleSubmit () {
      this.success = false
      this.error = false

      this.$refs.createParkingForm.validate();
      if (!this.isValid) {
        return
      }

    this.parkingCreate()
    this.scrollToTop()
    },
    parkingCreate () {
      const parkingData = {
        status: this.status,
        coordinates: this.coordinates,
        totalArea: +this.totalArea,
        price: +this.price,
        isBokalParking: this.isBokalParking,
        floorId: this.selectedFloor,
        entranceId: this.selectedEntrance,
        buildingId: this.selectedBuilding,
        ...this.parkingContent
      }

      try {
        updateParking(this.$route.params.id, parkingData)
          .then(response => {
            const { success } = response.data
            this.success = success
            this.error = !this.success

            this.reset()
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    scrollToTop () {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    reset () {
      this.$refs.createParkingForm.reset()
    }
  }
}
</script>

<style lang="scss">
.v-form.parking-create-form {
  width: 100%;
}
.ql-container.ql-snow,
.ql-toolbar.ql-snow {
  border-color: rgba(0,0,0,.42);
}
.ql-container.ql-snow {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.quillWrapper {
  margin-top: 15px;
}
.theme--light.v-tabs-items {
  background: transparent;
}
</style>
